import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { SendSBWarrantsPayload } from './send-sb-warrants.type';

// createSilobagService
export async function SendSilobagWarrantsService(body: SendSBWarrantsPayload) {
  const { response, data } = await BACKEND.post(ENDPOINT.WARRANT_QUOTE_REQUEST, { body });

  return {
    response,
    summary: data,
  };
}
